// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1pglp3kn{animation-timing-function:linear}\n._5sag12o8{animation-duration:1.5s}\n._7hjf1yy8{animation-direction:alternate}\n._bfhkn82g{background-color:var(--ds-skeleton,#091e420f)}\n._j7hq586c{animation-name:kskr1ph}\n._tip812c5{animation-iteration-count:infinite}\n@keyframes kskr1ph{0%{background-color:var(--ds-skeleton-from-color,var(--ds-skeleton,#091e420f))}to{background-color:var(--ds-skeleton-to-color,var(--ds-skeleton-subtle,#091e4208))}}", ""]);
// Exports
module.exports = exports;
